const map = {
	"./CROWD_SALE.json": 54404,
	"./CROWD_SALE_V2.json": 4673,
	"./ERC20_TOKEN.json": 7559,
	"./USDT_CONTRACT.json": 79724,
	"./VESTING_CONTRACT.json": 47840
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15446;